import Cards from "../../component/Cards";
import PageLayout from "../../component/PageLayout";
import IconHome from "../../component/SvgIcon/IconHome";

import UsersCardsNewMap from "../../component/UsersCards/indexNewmap";

export default function DashboardNew() {
  return (
    <PageLayout icon={<IconHome />} pagetitle="Dashboard">  
    <div className="topspace">
    <div className="container-fluid">
      <Cards/> 
      <UsersCardsNewMap/>
      </div>   
      </div>    
    </PageLayout>    
  );
}
